function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire06a3"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire06a3"] = parcelRequire;
}
parcelRequire.register("c1lIA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8c066cc8bb362538$export$6503ec6e8aabbaf; }, function (v) { return $8c066cc8bb362538$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $8c066cc8bb362538$export$f7ad0328861e2f03; }, function (v) { return $8c066cc8bb362538$export$f7ad0328861e2f03 = v; });
var $8c066cc8bb362538$export$6503ec6e8aabbaf;
var $8c066cc8bb362538$export$f7ad0328861e2f03;
"use strict";
var $8c066cc8bb362538$var$mapping = {};
function $8c066cc8bb362538$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$8c066cc8bb362538$var$mapping[keys[i]] = pairs[keys[i]];
}
function $8c066cc8bb362538$var$resolve(id) {
    var resolved = $8c066cc8bb362538$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$8c066cc8bb362538$export$6503ec6e8aabbaf = $8c066cc8bb362538$var$register;
$8c066cc8bb362538$export$f7ad0328861e2f03 = $8c066cc8bb362538$var$resolve;

});

var $c481f55ed410e7a8$exports = {};

(parcelRequire("c1lIA")).register(JSON.parse('{"4tTlI":"index.0c8f25e6.js","4MCte":"earth.1cb632e3.png","dQfeM":"space.1473ddc3.png","khLh4":"index.337a49d6.css"}'));


//# sourceMappingURL=index.91c16586.js.map
